<template>
  <div class="wrapper">
    <base-bread-crumb
      class="bread-crumb"
      :currBreadCrumb="currBreadCrumb"
      :isShowPortal="false"
    ></base-bread-crumb>
    <div class="ccui-home-app-container-detail">
      <div class="ccui-app-container announcementDetail">
        <div class="detail-title">{{ pageData.title }}</div>
        <div class="color-1 detail-info">
          <span class="pr20">作者：{{ pageData.author }}</span>
          <span class="pr20">发布时间：{{ pageData.publishTime }}</span>
        </div>
        <el-divider></el-divider>
        <div
          v-html="pageData.cmsTextContentBO.textContent"
          style="line-break: anywhere; font-size: 12px; line-height: 22px;"
        ></div>
        <!-- 附件信息 -->
        <attachmentUpload
          style="padding-top: 20px;"
          :type="2"
          :fileData="fileData"
          :isShowDesc="source === '1'"
          v-if="fileData.length > 0"
        ></attachmentUpload>
      </div>
    </div>
  </div>
</template>

<script>
import BaseBreadCrumb from "../components/baseBreadCrumb";
import { qryNoticeInfoDetails } from "../api/index";
import attachmentUpload from "@/basa/components/common/attachmentUpload1";
import moment from "moment";
export default {
  name: "announcementDetail",
  components: {
    BaseBreadCrumb,
    attachmentUpload
  },
  data() {
    return {
      moment: moment,
      pageData: {
        cmsTextContentBO: {
          textContent: ""
        }
      },
      currBreadCrumb: [
        {
          title: "首页",
          path: "/"
        },
        {
          title: "通知公告",
          path: "/noticeList"
        }
      ],
      fileData: [],
      routeType: "",
      source: this.$route.query.source //1->供应商投标操作流程   else->公告详情
    };
  },
  activated() {
    this.init();
  },
  computed: {},
  mounted() {
    if (this.$route.query.type) {
      this.routeType = this.$route.query.type;
      if (this.routeType == "noticeType") {
        this.currBreadCrumb = [
          {
            title: "首页",
            path: "/"
          },
          { title: "通知公告", path: "/noticeList?type=noticeType" }
        ];
      } else if (this.routeType == "lawType") {
        this.currBreadCrumb = [
          {
            title: "首页",
            path: "/"
          },
          { title: "政策法规", path: "/noticeList?type=lawType" }
        ];
      }
    }
  },
  methods: {
    init() {
      qryNoticeInfoDetails({
        noticeId: this.$route.query.id,
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          this.pageData = res.data.data;
          this.fileData = res.data.data.cmsFileInfoBOList.map(item => {
            item.fileSize = Math.round(item.fileSize / 1024);
            return item;
          });
          if (this.currBreadCrumb.length === 2) {
            this.currBreadCrumb.push({ title: this.pageData.title });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/*.ccui-home-app-container-detail {
  min-height: calc(100vh - 561px);
  margin: 0 auto 0 !important;
  padding: 0 0 0;
  min-width: 1180px;
}*/
.announcementDetail {
  .detail-title {
    font-size: 20px;
    padding-bottom: 10px;
    padding-top: 5px;
    color: #4a4a4a;
    letter-spacing: 0;
    font-weight: 600;
  }

  .detail-info {
    font-size: 12px;
  }

  .el-divider--horizontal {
    margin: 20px 0 16px 0;
  }
}

.bread-crumb {
  padding: 20px 0;
  margin: 0 !important;
}

::v-deep img {
  max-width: 100%;
}
</style>
